import { Component, OnDestroy, OnInit } from '@angular/core';
import { WindowRef } from '@spartacus/core';

@Component({
  selector: 'cx-onetrust-cookie',
  templateUrl: './custom-onetrust-cookie.component.html',
  styleUrls: ['./custom-onetrust-cookie.component.scss'],
  standalone: false
})
export class CustomOnetrustCookieComponent implements OnInit, OnDestroy {
  constructor(protected winRef: WindowRef) {
  }

  ngOnInit(): void {
    if (!this.winRef.sessionStorage.getItem('cookiesPageRefresh')) {
      this.winRef.location.reload();
      this.winRef.sessionStorage.setItem('cookiesPageRefresh', '1');
    }
  }

  ngOnDestroy(): void {
    if (this.winRef.sessionStorage) {
      this.winRef.sessionStorage.removeItem('cookiesPageRefresh');
    }
  }
}
